import { AfterViewInit, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { Alert, AlertService, MbsPopupType } from 'mbs-ui-kit';
import { EmailServiceStatus } from 'mbs-ui-shared/src/lib/models/Notification';
import { AppPersistentStateService } from 'mbs-ui-shared@services/app-persistent-state.service';
import { NotificationServerSettingsService } from 'mbs-ui-shared@services/notification-server-settings.service';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-email-service-status-component',
  imports: [RouterLink, I18NextPipe],
  templateUrl: './email-service-status.component.html'
})
export class EmailServiceStatusComponent implements AfterViewInit {
  private appStorage = inject(AppPersistentStateService);
  private notificationService = inject(NotificationServerSettingsService);
  private alertService = inject(AlertService);

  @ViewChild('alertTemplate', { static: true }) alertTemplate: TemplateRef<any>;

  ngAfterViewInit(): void {
    if (this.appStorage.data.showUnconfiguredEmailNotifications) {
      this.notificationService
        .checkEmailServiceConfigured()
        .pipe(
          filter((status) => status !== EmailServiceStatus.Ready),
          untilDestroyed(this)
        )
        .subscribe(() => {
          // may not appear without queueMicrotask because of 'speed run'
          queueMicrotask(() =>
            this.alertService.alert(new Alert({ content: this.alertTemplate, keepAfterRouteChange: true, type: MbsPopupType.danger }))
          );
          this.appStorage.data.showUnconfiguredEmailNotifications = false;
        });
    }
  }
}
